<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {ref} from "vue";
import {ElLoading, ElMessage} from "element-plus";


import Plotly from 'plotly.js-dist'

const plot1 = ref(null)

import {nextTick} from 'vue'


const activeNames = ref(['1'])
const species = ref('homo')
const genesymbol = ref('')
const ensembl = ref('')
const summary = ref('')
const alias = ref('')
const description = ref('')
const gene = ref('B2M')
const cid = ref('')

const istableshow = ref(false)
const noDataTip = ref(false)
//表格数据
let expressionList = ref([])
let plotList = ref([])
let tableList = ref([])
let gene_cidList = ref([])
let herbList = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [5, 20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(5)
//axios请求
import {inject} from 'vue'
import ElementPlus from "element-plus";

const $axios = inject('$axios')

const goSearch = ref('')

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function cancel() {
  gene.value = ''
}

function searchExpression() {
  expressionList.value = []
  goSearch.value = ''
  istableshow.value = false
  if (gene.value != '') {
    const loadingInstance = ElLoading.service({
      fullscreen: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)',
      lock: true
    })
    if (species.value != 'mouse') {
      $axios.get(' http://bioinfo-sysu.com:8484/api/gene_search',
          {
            params: {
              gene: gene.value,
              species: species.value
            },
          }).then((resp) => {
        if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
          expressionList.value = JSON.parse(JSON.stringify(resp.data))['list']
          genesymbol.value = expressionList.value[0]['fields']['symbol']
          ensembl.value = expressionList.value[0]['fields']['ensembl']
          $axios.get('http://bioinfo-sysu.com:8181/api/human_gene_search',
              {
                params: {
                  gene: genesymbol.value,
                },
              }).then((resp) => {
            if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
              tableList.value = JSON.parse(JSON.stringify(resp.data))['list']
              summary.value = tableList.value[0]['fields']['summary']
              alias.value = tableList.value[0]['fields']['alias']
              description.value = tableList.value[0]['fields']['description']
              $axios.get('http://bioinfo-sysu.com:8181/api/gene_cid_search',
                  {
                    params: {
                      gene: genesymbol.value,
                    },
                  }).then((resp) => {
                if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
                  gene_cidList.value = JSON.parse(JSON.stringify(resp.data))['list']
                  cid.value = gene_cidList.value[0]['fields']['cid']
                  $axios.get('http://bioinfo-sysu.com:8181/api/herb_cid_search',
                      {
                        params: {
                          ingredients: cid.value,
                        },
                      }).then((resp) => {
                    if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
                      herbList.value = JSON.parse(JSON.stringify(resp.data))['list']
                    }
                  }).catch((err) => {
                    console.log(err)
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
            }
          }).catch((err) => {
            console.log(err)
          })
          istableshow.value = true
          if (expressionList.value.length == 0) {
            noDataTip.value = true
          } else {
            noDataTip.value = false
          }
          loadingInstance.close()
        }
      }).catch((err) => {
        console.log(err)
      })
    } else if (species.value == 'mouse') {
      $axios.get('http://bioinfo-sysu.com:8484/api/gene_search',
          {
            params: {
              gene: gene.value,
              species: species.value
            },
          }).then((resp) => {
        if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
          expressionList.value = JSON.parse(JSON.stringify(resp.data))['list']
          genesymbol.value = expressionList.value[0]['fields']['symbol']
          ensembl.value = expressionList.value[0]['fields']['ensembl']
          $axios.get('http://bioinfo-sysu.com:8181/api/mouse_gene_search',
              {
                params: {
                  gene: genesymbol.value,
                },
              }).then((resp) => {
            if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
              tableList.value = JSON.parse(JSON.stringify(resp.data))['list']
              summary.value = tableList.value[0]['fields']['summary']
              alias.value = tableList.value[0]['fields']['alias']
              description.value = tableList.value[0]['fields']['description']
            }
          }).catch((err) => {
            console.log(err)
          })
          istableshow.value = true
          if (expressionList.value.length == 0) {
            noDataTip.value = true
          } else {
            noDataTip.value = false
          }
          loadingInstance.close()
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  } else {
    ElMessage({
      dangerouslyUseHTMLString: true,
      showClose: true,
      message: '<p>Sorry,please input your data.</p>',
      type: 'error',
      center: true,
    })
  }
}

const dialogVisible = ref(false)
const plot2 = ref(null)

async function fetchExpression(project, compare) {

  const url = `http://bioinfo-sysu.com:8484/api/gene_expression_boxplot?gene=${gene.value}&species=${species.value}&project=${project}&compare=${compare}`

  try {

    const res = await fetch(url)
    const data = await res.json()

    plotList.value = data

    dialogVisible.value = true

    await nextTick()

    drawBoxPlot()

  } catch (err) {
    console.error("API error:", err)
  }

}

function drawBoxPlot() {

  const dataObj = plotList.value

  if (!dataObj || !dataObj.data) {
    Plotly.purge(plot2.value)
    return
  }

  const groups = dataObj.groups
  const dataset = dataObj.data

  const traces = []

  groups.forEach(group => {
    const groupData = dataset.find(d => d.group === group)
    if (!groupData) return

    const values = []
    const samples = []

    groupData.values.forEach((v, i) => {
      if (v !== null) {
        values.push(v)
        samples.push(groupData.samples[i])
      }
    })

    traces.push({
      y: values,
      text: samples,   // hover显示SampleID
      type: "box",
      name: group,     // 关键：只用name，不用x

      boxpoints: "all",
      jitter: 0.4,
      pointpos: 0,

      marker: {size: 6, opacity: 0.6},
      line: {width: 2},

      hovertemplate:
          "<b>Sample:</b> %{text}" +
          "<br><b>Group:</b> " + group +
          "<br><b>Expression:</b> %{y:.3f}" +
          "<extra></extra>"
    })
  })

  const layout = {
    title: {text: `${gene.value} expression`, x: 0.5},
    yaxis: {title: "Expression", zeroline: false},
    xaxis: {title: "Groups", categoryorder: "array", categoryarray: groups},
    boxmode: "overlay",   // 关键修改
    plot_bgcolor: "white",
    paper_bgcolor: "white",
    margin: {t: 60, b: 60, l: 70, r: 30}
  }

  Plotly.newPlot(plot2.value, traces, layout, {displaylogo: false, responsive: true})

}
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12">
          <div class="text-center mb-8">
              <span class="text-blueGray-500 text-lg font-bold" style="font-size:35px">
                Gene Expression Interactive Analysis
               </span>
          </div>
        </div>
        <div class="col-12">
          <div class="py-10 border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed" style="color: #ccc;">
                  The indicators in search box are "symbol".
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center flex-column">
          <div class="col-12">
            <table class="table table-md align-middle table-borderless"
                   style="table-layout:fixed">
              <tbody>
              <tr>
                <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%;text-align: right;">
                  Gene
                </td>
                <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 20%;text-align: center">
                  <select class="form-select form-select-lg mx-1" aria-label=".form-select-lg example"
                          v-model="species"
                          style="color: #ccc;">
                    <option value="homo" style="color: black;">human</option>
                    <option value="mouse" style="color: black;">mouse</option>
                    <option value="cellline" style="color: black;">cell line</option>
                  </select>
                </td>
                <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%;text-align: center">
                  <input class="form-control form-control-lg mx-4" type="text" aria-label=".form-control-lg example"
                         style="width: 90%" v-model="gene">
                </td>
                <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 20%;text-align: left;">
                  <span style="color: #ccc;">
                    e.g., "B2M"
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="align-self-center">
            <button
                class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-base px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 mx-2"
                type="button"
                @click="searchExpression">
              Search
            </button>
            <button
                class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-base px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 mx-2"
                type="button"
                @click="cancel">
              Cancel
            </button>
          </div>
          <div class="gene-card col-12 my-4" style="
    border: 3px solid #3b82f6;
    border-radius: 16px;
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
    overflow: hidden;
    position: relative;
" v-if="istableshow">
            <div class="card-content" style="padding: 25px;">
              <!-- 卡片内容保持不变 -->
              <div class="info-group" style="margin-bottom: 25px;">
                <div class="info-label" style="
                font-size: 20px;
                font-weight: 700;
                color: #1e40af;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
            ">
                  <i class="fas fa-dna" style="margin-right: 12px; color: #3b82f6;"></i> Gene Symbol
                </div>
                <div class="info-value" style="
                font-size: 18px;
                font-weight: 600;
                color: #1f2937;
                background: #f9fafb;
                padding: 15px;
                border-radius: 10px;
                border-left: 4px solid #3b82f6;
            ">{{ expressionList[0]['fields'].symbol }}
                </div>
              </div>

              <div class="info-group" style="margin-bottom: 25px;">
                <div class="info-label" style="
          font-size: 20px;
          font-weight: 700;
          color: #1e40af;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
      ">
                  <i class="fas fa-code" style="margin-right: 12px; color: #3b82f6;"></i> Ensembl ID
                </div>
                <div class="info-value" style="
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          background: #f9fafb;
          padding: 15px;
          border-radius: 10px;
          border-left: 4px solid #3b82f6;
      ">{{ expressionList[0]['fields'].ensembl }}
                </div>
              </div>

              <div class="info-group" style="margin-bottom: 25px;">
                <div class="info-label" style="
          font-size: 20px;
          font-weight: 700;
          color: #1e40af;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
      ">
                  <i class="fas fa-file-alt" style="margin-right: 12px; color: #3b82f6;"></i> Description
                </div>
                <div class="info-value" style="
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          background: #f9fafb;
          padding: 15px;
          border-radius: 10px;
          border-left: 4px solid #3b82f6;
      ">{{ description }}
                </div>
              </div>

              <div class="info-group" style="margin-bottom: 25px;" v-if="species=='human'">
                <div class="info-label" style="
          font-size: 20px;
          font-weight: 700;
          color: #1e40af;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
      ">
                  <i class="fas fa-tags" style="margin-right: 12px; color: #3b82f6;"></i> Alias
                </div>
                <div class="info-value" style="
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          background: #f9fafb;
          padding: 15px;
          border-radius: 10px;
          border-left: 4px solid #3b82f6;
      ">{{ alias }}
                </div>
              </div>
              <div class="info-label" style="
          font-size: 20px;
          font-weight: 700;
          color: #1e40af;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
      ">
                <i class="fas fa-flask" style="margin-right: 12px; color: #3b82f6;"></i> PubChem CID of Targeted
                Compounds
              </div>
              <div class="info-value" style="
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  background: #f9fafb;
  padding: 15px;
  border-radius: 10px;
  border-left: 4px solid #3b82f6;
">
                <template v-for="(cidItem, index) in cid.split('|')" :key="cidItem">
                  <el-tooltip
                      placement="top"
                      :hide-after="100"
                      effect="light"
                  >
                    <template #content>
                      <img
                          :src="`https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/cid/${cidItem}/PNG`"
                          :alt="`Structure of CID ${cidItem}`"
                          style="width:200px; height:auto; border-radius:8px; border:1px solid #ccc;"
                          onerror="this.src='https://pubchem.ncbi.nlm.nih.gov/images/pubchem_logo.png'"
                      />
                    </template>

                    <a
                        :href="`https://pubchem.ncbi.nlm.nih.gov/compound/${cidItem}`"
                        target="_blank"
                        style="color: #3b82f6; text-decoration: none;"
                    >
                      {{ cidItem }}
                    </a>
                  </el-tooltip>

                  <span v-if="index < cid.split('|').length - 1">, </span>
                </template>
              </div>


              <div class="info-group" style="margin-bottom: 25px;" v-if="species=='human'">
                <div class="info-label" style="
    font-size: 20px;
    font-weight: 700;
    color: #1e40af;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  ">
                  <i class="fas fa-leaf" style="margin-right: 12px; color: #3b82f6;"></i> Herb
                </div>

                <div class="herb-table-container" style="
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  ">
                  <table class="herb-table" style="
      width: 100%;
      border-collapse: collapse;
      font-size: 16px;
    ">
                    <thead>
                    <tr style="background: linear-gradient(to right, #3b82f6, #1e40af);">
                      <th style="
            padding: 15px;
            color: white;
            font-weight: 600;
            text-align: center;
            width: 20%;
          ">Pinyin.Name
                      </th>
                      <th style="
            padding: 15px;
            color: white;
            font-weight: 600;
            text-align: center;
            width: 20%;
          ">Chinese.Name
                      </th>
                      <th style="
            padding: 15px;
            color: white;
            font-weight: 600;
            text-align: center;
            width: 30%;
          ">English.Name
                      </th>
                      <th style="
            padding: 15px;
            color: white;
            font-weight: 600;
            text-align: center;
            width: 30%;
          ">Latin.Name
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in herbList.slice((currentPage-1)*PageSize, currentPage*PageSize)"
                        :key="index"
                        :style="{
              backgroundColor: index % 2 === 0 ? '#f8fafc' : '#ffffff'
            }">
                      <td style="
            padding: 15px;
            text-align: center;
            color: #1f2937;
            border-bottom: 1px solid #e5e7eb;
          ">
                        <a
                            href="http://bionet.ncpsb.org.cn/batman-tcm/#/search"
                            target="_blank"
                            style="color: #3b82f6; text-decoration: none;"
                        >
                          {{ item.pinyin }}
                        </a>
                      </td>
                      <td style="
            padding: 15px;
            text-align: center;
            color: #1f2937;
            border-bottom: 1px solid #e5e7eb;
          ">{{ item.chinese }}
                      </td>
                      <td style="
            padding: 15px;
            text-align: center;
            color: #1f2937;
            border-bottom: 1px solid #e5e7eb;
          ">{{ item.english }}
                      </td>
                      <td style="
            padding: 15px;
            text-align: center;
            color: #1f2937;
            font-style: italic;
            border-bottom: 1px solid #e5e7eb;
          ">{{ item.latin }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <el-pagination
                      class="el-pager mt-3"
                      style="
        --el-color-primary: #3b82f6;
        padding: 15px;
        background: #f9fafb;
        border-top: 1px solid #e5e7eb;
      "
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="pageSizes"
                      :page-size="PageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="herbList.length">
                  </el-pagination>
                </div>
              </div>

              <div class="info-group" style="margin-bottom: 25px;">
                <div class="info-label" style="
                font-size: 20px;
                font-weight: 700;
                color: #1e40af;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
            ">
                  <i class="fas fa-book" style="margin-right: 12px; color: #3b82f6;"></i> Summary
                </div>
                <div class="info-value summary" style="
                font-size: 16px;
                line-height: 1.8;
                color: #374151;
                background: #eff6ff;
                padding: 20px;
                border-radius: 12px;
                border-left: 4px solid #3b82f6;
            ">{{ summary }}
                </div>
              </div>

              <div class="info-group">
                <div class="info-label" style="
                font-size: 18px;
                font-weight: 700;
                color: #1e40af;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
            ">
                  <i class="fas fa-external-link-alt" style="margin-right: 10px; color: #3b82f6; font-size: 16px;"></i>
                  Lookup this gene in:
                </div>

                <div class="database-links" style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                justify-content: center;
            ">
                  <!-- GeneCard 按钮 -->
                  <a :href="'https://www.genecards.org/cgi-bin/carddisp.pl?gene='+genesymbol"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                    display: inline-block;
                ">GeneCard</a>

                  <!-- NCBI 按钮 -->
                  <a :href="'https://www.ncbi.nlm.nih.gov/gene/?term='+ensembl.split('.')[0]"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">NCBI</a>

                  <!-- Ensembl 按钮 -->
                  <a :href="'https://www.ensembl.org/Homo_sapiens/Gene/Summary?g='+genesymbol"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">Ensembl</a>

                  <!-- EBI 按钮 -->
                  <a :href="'http://www.ebi.ac.uk/gxa/query?geneQuery='+genesymbol"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">EBI</a>

                  <!-- OMIM 按钮 -->
                  <a :href="'https://omim.org/search/?search='+genesymbol"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">OMIM</a>

                  <!-- COSMIC 按钮 -->
                  <a :href="'https://cancer.sanger.ac.uk/cosmic/gene/analysis?ln='+genesymbol"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">COSMIC</a>

                  <!-- HPA 按钮 -->
                  <a :href="'http://www.proteinatlas.org/'+ensembl.split('.')[0]+'-'+genesymbol+'/tissue'"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">HPA</a>

                  <!-- DrugBank 按钮 -->
                  <a :href="'https://go.drugbank.com/unearth/q?searcher=bio_entities&query='+genesymbol+'&button='"
                     target="_blank"
                     class="database-btn"
                     style="
                    background-color: #64748b;
                    color: white;
                    border-radius: 6px;
                    padding: 6px 12px;
                    text-align: center;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.2s;
                    min-width: 100px;
                ">DrugBank</a>
                </div>
              </div>
            </div>
          </div>
          <div id="tablePagination" class="row justify-content-center" v-if="istableshow">
            <!--            <div class="col-3">-->
            <!--              <div class="demo-collapse mt-4">-->
            <!--                <div class="collapse-header">-->
            <!--                  Analysis Filters-->
            <!--                  <span class="collapse-icon">▼</span>-->
            <!--                </div>-->
            <!--                <el-collapse v-model="activeNames" @change="handleChange">-->
            <!--                  <el-collapse-item title="Data Type" name="1">-->
            <!--                    <el-checkbox-group v-model="datatype">-->
            <!--                      <el-checkbox class="custom-checkbox" label="Microarray">DNA microarray</el-checkbox>-->
            <!--                      <el-checkbox class="custom-checkbox" label="Bulk">Bulk RNA-seq</el-checkbox>-->
            <!--                      <el-checkbox class="custom-checkbox" label="Single">Single cell RNA-seq</el-checkbox>-->
            <!--                    </el-checkbox-group>-->
            <!--                  </el-collapse-item>-->
            <!--                  <el-collapse-item title="Project" name="1">-->
            <!--                    <el-checkbox-group v-model="project">-->
            <!--                      <el-checkbox class="custom-checkbox" label="PRJNA1163973">PRJNA1163973</el-checkbox>-->
            <!--                      <el-checkbox class="custom-checkbox" label="PRJEB40032">PRJEB40032</el-checkbox>-->
            <!--                    </el-checkbox-group>-->
            <!--                  </el-collapse-item>-->
            <!--                  <el-collapse-item title="Significance" name="1">-->
            <!--                    <el-checkbox-group v-model="significance">-->
            <!--                      <el-checkbox class="custom-checkbox" label="yes">Statistically Significant</el-checkbox>-->
            <!--                      <el-checkbox class="custom-checkbox" label="no">Statistically Insignificant</el-checkbox>-->
            <!--                    </el-checkbox-group>-->
            <!--                  </el-collapse-item>-->
            <!--                </el-collapse>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="col-12">
              <table class="table table-striped table-sm align-middle mt-4"
                     style="text-align: center;table-layout:fixed;font-size:18px">
                <thead>
                <tr>
                  <th scope="col" style="width: 10%" class="pe-0 ps-0">Project</th>
                  <th scope="col" style="width: 20%" class="pe-0 ps-0">log2FoldChange</th>
                  <th scope="col" style="width: 20%" class="pe-0 ps-0">Pvalue</th>
                  <th scope="col" style="width: 20%" class="pe-0 ps-0">Padj</th>
                  <th scope="col" style="width: 20%" class="pe-0 ps-0">Group</th>
                  <th scope="col" style="width: 10%" class="pe-0 ps-0">Significance</th>
                  <th scope="col" style="width: 10%" class="pe-0 ps-0">Plot</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in expressionList">
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    <el-link type="primary"
                             :href="'https://www.ncbi.nlm.nih.gov/bioproject/?term='+item['fields'].project"
                             target="_blank">
                      {{ item['fields'].project }}
                    </el-link>
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ item['fields'].logfc }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ item['fields'].pvalue }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ item['fields'].fdr }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{ item['fields'].condition }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    {{
                      (Math.abs(Number(item['fields'].logfc)) >= 1 && Number(item['fields'].fdr) <= 0.05) ? 'Yes' : 'No'
                    }}
                  </td>
                  <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                    <button
                        class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-base px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 mx-2"
                        type="button"
                        @click="fetchExpression(item['fields'].project,item['fields'].condition)">
                      Plot
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="row justify-content-center" v-show="noDataTip">
                <label style="text-align: center;font-size: 18px" class="mt-4">No data available in table</label>
              </div>
            </div>
          </div>
          <div class="gene-search col-12">
            <el-dialog
                v-model="dialogVisible"
                width="70%"
                title="Gene Expression Boxplot"
                destroy-on-close
            >

              <div ref="plot2" style="width:100%; height:500px;"></div>

            </el-dialog>
          </div>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
<style scoped>
/* 全局修改折叠面板样式 */
:deep(.el-collapse-item__header) {
  font-size: 25px; /* 大字体 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 深灰色 */
  margin: 12px 0px 12px 0;
  //padding: 12px 0;       /* 增加内边距 */
}

/* 可选：添加悬停效果 */
:deep(.el-collapse-item__header:hover) {
  color: #0070c0; /* 悬停时改为蓝色 */
}

/* 可选：修改展开箭头样式 */
:deep(.el-collapse-item__arrow) {
  font-size: 20px;
  font-weight: bold;
  margin-right: 8px;
}

:deep(.el-checkbox-group) {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  gap: 10px; /* 行间距 */
}

:deep(.el-checkbox) {
  width: 100%; /* 占满整行 */
}

:deep(.custom-checkbox .el-checkbox__label) {
  color: #333; /* 与图片一致的蓝色 */
  font-size: 15px;
  font-weight: 500; /* 中等加粗 */
}

:deep(.el-tooltip__popper img) {
  max-width: 250px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.gene-search {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

input {
  padding: 6px 10px;
  font-size: 14px;
}

button {
  padding: 6px 12px;
  cursor: pointer;
}

</style>